import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Button, Container, Image } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import "../Common/Common.css";
import "./ResetPwd.css";

class ResetPwd extends Component {
  constructor() {
    super();
    this.state = {
      regmobileNo: "",
      regnewpwd: "",
      regnewpwdError: "",
      regconfpwd: "",
      regconfpwdError: "",
      showNewPassword: false,
      showConfirmPassword: false
    };
  }

  togglePasswordVisibility = field => {
    this.setState(prevState => ({
      [field]: !prevState[field]
    }));
  };

  resetOnChange = event => {
    let val = event.target.value;
    let name = event.target.name;

    if (name === "regnewpwd") {
      if (val.length < 6) {
        this.setState({
          ...this.state,
          regnewpwd: val,
          regnewpwdError: "Minimum 6 digits/characters needed"
        });
      } else {
        this.setState({
          ...this.state,
          regnewpwd: val,
          regnewpwdError: ""
        });
      }
    }
    if (name === "regconfpwd") {
      if (this.state.regnewpwd !== "" && val !== this.state.regnewpwd) {
        this.setState({
          ...this.state,
          regconfpwd: val,
          regconfpwdError: "Passwords should match"
        });
      } else {
        this.setState({
          ...this.state,
          regconfpwd: val,
          regconfpwdError: ""
        });
      }
    }
  };

  validateNo = () => {
    let isError = false;

    const err = "Password mismatch";
    const err1 = "This field is mandatory";

    const errors = {
      regnewpwdError: "",
      regconfpwdError: ""
    };

    if (this.state.regnewpwd === "") {
      isError = true;
      errors.regnewpwdError = err1;
    }
    if (this.state.regconfpwd === "") {
      isError = true;
      errors.regconfpwdError = err1;
    }

    if (
      this.state.regnewpwd !== "" &&
      this.state.regconfpwd !== "" &&
      this.state.regconfpwd !== this.state.regnewpwd
    ) {
      isError = true;
      errors.regconfpwdError = err;
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  resetPwd = () => {
    let validate = this.validateNo();

    if (!validate) {
      const data = {
        mob: this.state.regmobileNo,
        newpwd: this.state.regnewpwd
      };

      this.props.resetOriginalPwd(data);

      this.setState({
        regnewpwd: "",
        regconfpwd: ""
      });
    }
  };

  render() {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    console.log(user);
    return (
      <div className="salesreturndiv">
        <div>
          <Container>
            <Row>
              <Col xs={12} md={12} sm={12} className="main_colum">
                <Card className="cardresetMain">
                  <Row>
                    <Col xs={12} sm={12} md={6} lg={6}>
                      <div>
                        <h5 className="tablecardtitle resethead">Reset Password</h5>
                      </div>
                    </Col>

                    <Col xs={12} sm={12} md={6} lg={6}>
                      <div className="editprofclose resetclose">
                        <Link
                          to="/dashboard"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          <i className="fa fa-times fa-lg "></i>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                  <Card.Body>
                    <div className="forgotDiv">
                      <div>
                        <Image
                          className="resetimg"
                          src={require("../../assets/img/password-reset.png")}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="loginreset_form">

                        <Row>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Form.Group controlId="formGroupEmail">
                              <div className="reset-password-wrap">
                                <Form.Control
                                  type={this.state.showNewPassword ? "text" : "password"}
                                  name="regnewpwd"
                                  value={this.state.regnewpwd}
                                  onChange={this.resetOnChange}
                                  placeholder="New password"
                                  className="reset-password-field"
                                />
                                <button
                                  type="button"
                                  className="reset-password-toggle"
                                  onClick={() =>
                                    this.togglePasswordVisibility("showNewPassword")
                                  }
                                  aria-label={
                                    this.state.showNewPassword
                                      ? "Hide new password"
                                      : "Show new password"
                                  }
                                >
                                  <i
                                    className={`fa ${
                                      this.state.showNewPassword
                                        ? "fa-eye-slash"
                                        : "fa-eye"
                                    }`}
                                  />
                                </button>
                              </div>
                              <div className="reseterrStyle">
                                {this.state.regnewpwdError}
                              </div>
                            </Form.Group>
                          </Col>

                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Form.Group controlId="formGroupEmail">
                              <div className="reset-password-wrap">
                                <Form.Control
                                  type={
                                    this.state.showConfirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  name="regconfpwd"
                                  value={this.state.regconfpwd}
                                  onChange={this.resetOnChange}
                                  placeholder="Confirm password"
                                  className="reset-password-field"
                                />
                                <button
                                  type="button"
                                  className="reset-password-toggle"
                                  onClick={() =>
                                    this.togglePasswordVisibility(
                                      "showConfirmPassword"
                                    )
                                  }
                                  aria-label={
                                    this.state.showConfirmPassword
                                      ? "Hide confirm password"
                                      : "Show confirm password"
                                  }
                                >
                                  <i
                                    className={`fa ${
                                      this.state.showConfirmPassword
                                        ? "fa-eye-slash"
                                        : "fa-eye"
                                    }`}
                                  />
                                </button>
                              </div>
                              <div className="reseterrStyle">
                                {this.state.regconfpwdError}
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Card.Body>

                  <Button
                    className="resetqueryBtn"
                    // style={{ float: "right" }}
                    type="submit"
                    onClick={this.resetPwd}
                  >
                    Submit
                  </Button>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export default ResetPwd;
